import { User } from '@sendbird/chat';

export const directPermittedAccounts = ['Carer', 'Consumer'];

// TODO: GE-368 - Cleanup after chat refactor completion
// Commenting for now as the message is passed as baseMessage and the explicit conversion will be either done in the bubble or when its needed.
// export type MessageTypes = FileMessage | AdminMessage | UserMessage | MeetAndGreetMessage;

export enum MessageStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
}

export type SendBirdUser = User;

export enum CustomChannelType {
  OneOnOne = 'one_on_one',
  GroupChat = 'group_chat',
}
